import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class ProductSliderV6 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL + '/'

        return <div className="ltn__search-by-place-area before-bg-top bg-image-top--- pt-115 pb-70" data-bs-bg={publicUrl + "assets/img/bg/20.jpg"}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title-area ltn__section-title-2--- text-center---">
                            <h2 className="section-subtitle section-subtitle-2--- ltn__secondary-color">Other Services</h2>
                            <h1 className="section-title">House Construction</h1>
                        </div>
                    </div>
                </div>
                <div className="row ltn__search-by-place-slider-1-active slick-arrow-1 go-top">
                    <div className="col-lg-6">
                        <div className="ltn__search-by-place-item">
                            <div className="search-by-place-img">
                                <img src={publicUrl + "assets/img/projects/Krishna Nagar/img1.jpg"} alt="#" />
                            </div>
                            <div className="search-by-place-info">
                                <h6>Navallur</h6>
                                <h4>Krishna Nagar</h4>
                                <div className="search-by-place-btn">
                                    <Link to="/construction">View Projects <i className="flaticon-right-arrow" /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="ltn__search-by-place-item">
                            <div className="search-by-place-img">
                                <img src={publicUrl + "assets/img/projects/Ganesh Nagar/img2.jpg"} alt="#" />
                            </div>
                            <div className="search-by-place-info">
                                <h6>Malai Pattu</h6>
                                <h4>Ganesh Nagar</h4>
                                <div className="search-by-place-btn">
                                    <Link to="/construction">View Projects <i className="flaticon-right-arrow" /></Link>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    }
}

export default ProductSliderV6